import React, { useState, useEffect } from 'react';
import { X, Play, Sparkles, Volume2, User, CheckCircle, Loader, AlertCircle, Mic, ChevronDown } from 'lucide-react';
import { voiceService } from '../services/AiVoiceService';
import API_URL from '../config/API_URL';
export const BookViewerModal = ({ isOpen, onClose, book, familyId, allRecordings = [], familyReaders = [], kids = [] }) => {
  const [bookRecordings, setBookRecordings] = useState([]);
  console.log('------------------',allRecordings)
  console.log('------------------')
  // AI Generation State
  const [showAIFlow, setShowAIFlow] = useState(false);
  const [selectedReader, setSelectedReader] = useState(null);
  const [selectedKid, setSelectedKid] = useState(null);
  const [availabilityCheck, setAvailabilityCheck] = useState(null);
  const [isChecking, setIsChecking] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [generationError, setGenerationError] = useState(null);
  const [generationSuccess, setGenerationSuccess] = useState(false);
  const [verifiedReaders, setVerifiedReaders] = useState(familyReaders);


  
  // Voice Clone Creation State
  const [showVoiceCloneFlow, setShowVoiceCloneFlow] = useState(false);
  const [isCreatingClone, setIsCreatingClone] = useState(false);
  const [voiceCloneError, setVoiceCloneError] = useState(null);
  const [voiceCloneSuccess, setVoiceCloneSuccess] = useState(false);
  const [selectedReaderRecordings, setSelectedReaderRecordings] = useState([]);

  useEffect(() => {
    if (isOpen && book && allRecordings.length > 0) {
      const filtered = allRecordings.filter(recording => 
        recording.book_id === book.id || 
        (recording.book && recording.book.id === book.id)
      );
      setBookRecordings(filtered);
    } else if (isOpen && book) {
      setBookRecordings([]);
    }
    
    if (isOpen) {
      setShowAIFlow(false);
      setShowVoiceCloneFlow(false);
      setSelectedReader(null);
      setSelectedKid(null);
      setAvailabilityCheck(null);
      setGenerationError(null);
      setGenerationSuccess(false);
      setVoiceCloneError(null);
      setVoiceCloneSuccess(false);
    }
  }, [isOpen, book, allRecordings]);

  useEffect(() => {
    if (selectedReader && selectedKid && book) {
      checkAIAvailability();
    }
  }, [selectedReader, selectedKid, book]);

  useEffect(() => {
    if (isOpen && familyReaders.length > 0) {
          setVerifiedReaders(familyReaders);

      const verifyReaders = async () => {
        const verified = await Promise.all(
          familyReaders.map(async (reader) => {
            try {
              const response = await fetch(
                `${API_URL}/api/voice/check-voice-clone/${reader.id}`,
                { credentials: 'include' }
              );
              const data = await response.json();
              return { ...reader, has_voice_clone: data.has_voice_clone };
            } catch {
              return { ...reader, has_voice_clone: false };
            }
          })
        );
        
        // UPDATE THE STATE WITH VERIFIED READERS
        setVerifiedReaders(verified);
      };
      
      verifyReaders();
    }
  }, [isOpen, familyReaders]);

  const checkAIAvailability = async () => {
    setIsChecking(true);
    setAvailabilityCheck(null);
    setGenerationError(null);
    
    try {
      const result = await voiceService.checkAvailability(
        book.id,
        selectedReader.id,
        selectedKid.id
      );
      setAvailabilityCheck(result);
    } catch (error) {
      setGenerationError(error.message);
    } finally {
      setIsChecking(false);
    }
  };

  const handleStartVoiceClone = () => {
    if (!selectedReader) {
      setVoiceCloneError('Please select a reader first');
      return;
    }
    
    // Filter recordings for this reader
    const readerRecordings = allRecordings.filter(r => r.reader_id === selectedReader.id);
    
    if (readerRecordings.length === 0) {
      setVoiceCloneError(`${selectedReader.first_name} needs to record at least one story before creating a voice clone`);
      return;
    }
    
    setSelectedReaderRecordings(readerRecordings);
    setShowVoiceCloneFlow(true);
    setShowAIFlow(false);
  };

  const handleCreateVoiceClone = async (selectedRecordingIds) => {
    if (selectedRecordingIds.length === 0) {
      setVoiceCloneError('Please select at least one recording');
      return;
    }

    setIsCreatingClone(true);
    setVoiceCloneError(null);

    try {
      const result = await voiceService.createVoiceClone(
        selectedReader.id,
        selectedRecordingIds,
        `${selectedReader.first_name}'s Voice`
      );

      setVoiceCloneSuccess(true);
      setVoiceCloneError(null);
      
      // Update the reader's voice clone status
      selectedReader.has_voice_clone = true;
      
      setTimeout(() => {
        setShowVoiceCloneFlow(false);
        setShowAIFlow(true);
        setVoiceCloneSuccess(false);
      }, 2000);

    } catch (error) {
      setVoiceCloneError(error.message);
      setVoiceCloneSuccess(false);
    } finally {
      setIsCreatingClone(false);
    }
  };

  const handleGenerateAI = async () => {
    if (!selectedReader || !selectedKid) {
      setGenerationError('Please select both a reader and a kid');
      return;
    }

    setIsGenerating(true);
    setGenerationError(null);

    try {
      const result = await voiceService.generateStory(
        book.id,
        selectedReader.id,
        selectedKid.id,
        null
      );

      setGenerationSuccess(true);
      setGenerationError(null);
      
      setTimeout(() => {
        setShowAIFlow(false);
        setGenerationSuccess(false);
      }, 3000);

    } catch (error) {
      setGenerationError(error.message);
      setGenerationSuccess(false);
    } finally {
      setIsGenerating(false);
    }
  };

  const [isAISectionExpanded, setIsAISectionExpanded] = useState(false);


  const handleStartRecording = () => {
    const childIdParam =  '';
    const premiumParam = book.isPremium ? '&premium=true' : '';
    window.location.href = `/record?bookId=${book.id}${childIdParam}${premiumParam}`;
  };


  const handleStartAIFlow = () => {
    console.log(familyReaders)
    console.log(kids)
    if (!familyReaders || familyReaders.length === 0) {
      setGenerationError('No readers available in this family. Invite grandparents to join!');
      return;
    }
    
    if (!kids || kids.length === 0) {
      setGenerationError('No kids in this family. Add a kid first!');
      return;
    }

    setShowAIFlow(true);
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '1rem'
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '1rem',
          maxWidth: '1200px',
          width: '100%',
          maxHeight: '90vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            padding: '1.5rem',
            borderBottom: '1px solid #e5e7eb',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: '1rem'
          }}
        >
          <div style={{ flex: 1 }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '0.5rem' }}>
              {book?.title}
            </h2>
            <p style={{ color: '#6b7280', fontSize: '1rem' }}>by {book?.author}</p>
            {book?.description && (
              <p style={{ color: '#9ca3af', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                {book.description}
              </p>
            )}
          </div>
          <div
                style={{
                  background: 'linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%)',
                  borderRadius: '0.75rem',
                  padding: '1.5rem',
                  border: '2px solid #dbeafe'
                }}
              >
                <button
                  onClick={handleStartRecording}
                  style={{
                    width: '100%',
                    background: 'linear-gradient(135deg, #db2777 0%, #db2777 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '0.5rem',
                    padding: '0.75rem 1rem',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    boxShadow: '0 4px 6px -1px rgb(59 130 246 / 0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.02)';
                    e.currentTarget.style.boxShadow = '0 6px 12px -1px rgb(59 130 246 / 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 6px -1px rgb(59 130 246 / 0.3)';
                  }}
                >
                  <Volume2 size={20} />
                  Record Your Own
                  <Sparkles size={16} />
                </button>
                <p style={{ 
                  fontSize: '0.75rem', 
                  color: '#64748b', 
                  marginTop: '0.75rem',
                  textAlign: 'center',
                  fontStyle: 'italic'
                }}>
                  ⭐ Parents need to read bed time stories too
                </p>
              </div>
          <button
            onClick={onClose}
            style={{
              background: '#f3f4f6',
              border: 'none',
              borderRadius: '0.5rem',
              padding: '0.5rem',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = '#e5e7eb'}
            onMouseLeave={(e) => e.currentTarget.style.background = '#f3f4f6'}
          >
            <X size={24} color="#6b7280" />
          </button>
        </div>

        {/* Content */}
        <div
          style={{
            flex: 1,
            overflow: 'auto',
            display: 'grid',
            gridTemplateColumns: (showAIFlow || showVoiceCloneFlow) ? '1fr' : '2fr 1fr',
            gap: '1.5rem',
            padding: '1.5rem'
          }}
        >
          {/* PDF Viewer */}
          {!showAIFlow && !showVoiceCloneFlow && (
            <div>
              <div
                style={{
                  border: '2px solid #e5e7eb',
                  borderRadius: '0.75rem',
                  overflow: 'hidden',
                  background: '#f9fafb',
                  height: '600px'
                }}
              >
                {book?.pdf_url ? (
                  <iframe
                    src={book.pdf_url}
                    style={{
                      width: '100%',
                      height: '100%',
                      border: 'none'
                    }}
                    title={`${book.title} full view`}
                  />
                ) : (
                  <div
                    style={{
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#9ca3af'
                    }}
                  >
                    <p>PDF not available</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Voice Clone Creation Flow */}
          {showVoiceCloneFlow ? (
            <VoiceCloneCreationFlow
              reader={selectedReader}
              recordings={selectedReaderRecordings}
              isCreating={isCreatingClone}
              error={voiceCloneError}
              success={voiceCloneSuccess}
              onCreateClone={handleCreateVoiceClone}
              onCancel={() => {
                setShowVoiceCloneFlow(false);
                setShowAIFlow(true);
              }}
            />
          ) : showAIFlow ? (
            /* AI Generation Flow */
            <AIGenerationFlow
              familyReaders={verifiedReaders.length > 0 ? verifiedReaders : familyReaders}
              kids={kids}
              selectedReader={selectedReader}
              selectedKid={selectedKid}
              availabilityCheck={availabilityCheck}
              isChecking={isChecking}
              isGenerating={isGenerating}
              generationError={generationError}
              generationSuccess={generationSuccess}
              onSelectReader={setSelectedReader}
              onSelectKid={setSelectedKid}
              onStartVoiceClone={handleStartVoiceClone}
              onGenerate={handleGenerateAI}
              onCancel={() => setShowAIFlow(false)}
            />
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              {/* AI Reading Button */}
              
              <div
                style={{
                  background: 'linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%)',
                  borderRadius: '0.75rem',
                  padding: '1.5rem',
                  border: '2px solid #dbeafe',
                  transition: 'all 0.3s ease'
                }}
              >
                <div 
                  onClick={() => setIsAISectionExpanded(!isAISectionExpanded)}
                  style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    marginBottom: isAISectionExpanded ? '1rem' : '0'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <Sparkles size={24} color="#3b82f6" />
                    <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#1e40af' }}>
                      AI Reading Recording
                    </h3>
                  </div>
                  <div style={{
                    transform: isAISectionExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <ChevronDown size={24} color="#1e40af" />
                  </div>
                </div>

                {isAISectionExpanded && (
                  <div style={{
                    animation: 'slideDown 0.3s ease-out'
                  }}>
                    <p style={{ color: '#475569', fontSize: '0.875rem', marginBottom: '1rem' }}>
                      Generate an AI-powered narration using a grandparent's voice clone.
                    </p>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleStartAIFlow();
                      }}
                      style={{
                        width: '100%',
                        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '0.5rem',
                        padding: '0.75rem 1rem',
                        fontSize: '1rem',
                        fontWeight: '600',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5rem',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        boxShadow: '0 4px 6px -1px rgb(59 130 246 / 0.3)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.02)';
                        e.currentTarget.style.boxShadow = '0 6px 12px -1px rgb(59 130 246 / 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = '0 4px 6px -1px rgb(59 130 246 / 0.3)';
                      }}
                    >
                      <Volume2 size={20} />
                      Generate AI Reading
                      <Sparkles size={16} />
                    </button>
                    <p style={{ 
                      fontSize: '0.75rem', 
                      color: '#64748b', 
                      marginTop: '0.75rem',
                      textAlign: 'center',
                      fontStyle: 'italic'
                    }}>
                      ⭐ Premium feature - Subscription required
                    </p>
                  </div>
                )}
              </div>


              {/* Family Recordings */}
              <FamilyRecordingsSection recordings={bookRecordings} />
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

// Separate component for Family Recordings
const FamilyRecordingsSection = ({ recordings }) => (
  <div
    style={{
      background: 'white',
      borderRadius: '0.75rem',
      padding: '1.5rem',
      border: '1px solid #e5e7eb',
      flex: 1,
      display: 'flex',
      flexDirection: 'column'
    }}
  >
    <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>
      Family Recordings
      {recordings.length > 0 && (
        <span style={{ 
          marginLeft: '0.5rem', 
          fontSize: '0.875rem', 
          color: '#059669',
          fontWeight: '600',
          background: '#d1fae5',
          padding: '0.25rem 0.5rem',
          borderRadius: '0.375rem'
        }}>
          {recordings.length}
        </span>
      )}
    </h3>

    {recordings.length === 0 ? (
      <div style={{ textAlign: 'center', padding: '2rem 0' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.3 }}>📚</div>
        <p style={{ color: '#9ca3af', fontSize: '0.875rem', marginBottom: '0.5rem' }}>
          No family recordings yet
        </p>
        <p style={{ color: '#d1d5db', fontSize: '0.75rem' }}>
          Be the first to record this story!
        </p>
      </div>
    ) : (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', overflowY: 'auto', maxHeight: '400px' }}>
        {recordings.map((recording) => (
          <div
            key={recording.id}
            style={{
              border: '1px solid #e5e7eb',
              borderRadius: '0.5rem',
              padding: '1rem',
              background: '#fafafa',
              transition: 'transform 0.2s, box-shadow 0.2s',
              cursor: recording.video_url ? 'pointer' : 'default'
            }}
            onClick={() => {
              if (recording.video_url) {
                window.open(recording.video_url, '_blank');
              }
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
              <div
                style={{
                  fontSize: '1.25rem',
                  fontWeight: 'bold',
                  background: 'linear-gradient(135deg, #db2777, #be185d)',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  textTransform: 'uppercase',
                  flexShrink: 0
                }}
              >
                {recording.reader_avatar || recording.reader_name?.charAt(0) || 'R'}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontWeight: '600', color: '#1f2937', fontSize: '0.875rem', marginBottom: '0.125rem' }}>
                  {recording.reader_name}
                </p>
                {recording.kid_name && (
                  <p style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                    For {recording.kid_name}
                  </p>
                )}
              </div>
            </div>
            
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              paddingTop: '0.5rem',
              borderTop: '1px solid #e5e7eb'
            }}>
              <span style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
                {new Date(recording.created_at).toLocaleDateString()}
              </span>
              {recording.video_url && (
                <div
                  style={{
                    background: '#db2777',
                    color: 'white',
                    padding: '0.25rem 0.625rem',
                    fontSize: '0.75rem',
                    borderRadius: '0.375rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.375rem',
                    fontWeight: '600'
                  }}
                >
                  <Play size={12} /> Watch
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

// Voice Clone Creation Flow Component
const VoiceCloneCreationFlow = ({ reader, recordings, isCreating, error, success, onCreateClone, onCancel }) => {
  const [selectedIds, setSelectedIds] = useState([]);

  const toggleRecording = (id) => {
    setSelectedIds(prev => 
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', maxWidth: '700px', margin: '0 auto', width: '100%' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
          <Mic size={32} color="#3b82f6" />
          <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#1f2937' }}>
            Create Voice Clone
          </h2>
        </div>
        <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
          Select recordings to train {reader.first_name}'s AI voice
        </p>
      </div>

      <div style={{ 
        background: 'white', 
        border: '2px solid #e5e7eb', 
        borderRadius: '0.75rem', 
        padding: '1.5rem',
        maxHeight: '400px',
        overflowY: 'auto'
      }}>
        <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#1f2937', marginBottom: '1rem' }}>
          Available Recordings ({recordings.length})
        </h3>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {recordings.map((recording) => (
            <div
              key={recording.id}
              onClick={() => toggleRecording(recording.id)}
              style={{
                padding: '1rem',
                border: selectedIds.includes(recording.id) ? '2px solid #3b82f6' : '1px solid #e5e7eb',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                background: selectedIds.includes(recording.id) ? '#eff6ff' : 'white',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <div>
                <p style={{ fontWeight: '600', color: '#1f2937', marginBottom: '0.25rem' }}>
                  {recording.book_title || 'Untitled'}
                </p>
                <p style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                  {new Date(recording.created_at).toLocaleDateString()}
                </p>
              </div>
              {selectedIds.includes(recording.id) && (
                <CheckCircle size={24} color="#3b82f6" />
              )}
            </div>
          ))}
        </div>
      </div>

      {error && (
        <div style={{
          padding: '1rem',
          background: '#fee2e2',
          border: '1px solid #dc2626',
          borderRadius: '0.5rem',
          color: '#991b1b',
          fontSize: '0.875rem'
        }}>
          {error}
        </div>
      )}

      {success && (
        <div style={{
          padding: '1rem',
          background: '#d1fae5',
          border: '1px solid #059669',
          borderRadius: '0.5rem',
          color: '#065f46',
          fontSize: '0.875rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <CheckCircle size={20} color="#059669" />
          Voice clone created successfully!
        </div>
      )}

      <div style={{ display: 'flex', gap: '1rem' }}>
        <button
          onClick={onCancel}
          disabled={isCreating}
          style={{
            flex: 1,
            padding: '0.75rem 1.5rem',
            border: '1px solid #e5e7eb',
            borderRadius: '0.5rem',
            background: 'white',
            color: '#6b7280',
            fontWeight: '600',
            cursor: isCreating ? 'not-allowed' : 'pointer'
          }}
        >
          Cancel
        </button>
        <button
          onClick={() => onCreateClone(selectedIds)}
          disabled={selectedIds.length === 0 || isCreating}
          style={{
            flex: 2,
            padding: '0.75rem 1.5rem',
            border: 'none',
            borderRadius: '0.5rem',
            background: (selectedIds.length === 0 || isCreating) 
              ? '#d1d5db' 
              : 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            color: 'white',
            fontWeight: '600',
            cursor: (selectedIds.length === 0 || isCreating) ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem'
          }}
        >
          {isCreating ? (
            <>
              <Loader size={16} style={{ animation: 'spin 1s linear infinite' }} />
              Creating Voice Clone...
            </>
          ) : (
            <>
              <Mic size={16} />
              Create Voice Clone ({selectedIds.length} selected)
            </>
          )}
        </button>
      </div>
    </div>
  );
};

// AI Generation Flow Component
const AIGenerationFlow = ({ 
  familyReaders, kids, selectedReader, selectedKid, availabilityCheck, 
  isChecking, isGenerating, generationError, generationSuccess,
  onSelectReader, onSelectKid, onStartVoiceClone, onGenerate, onCancel
}) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', maxWidth: '600px', margin: '0 auto', width: '100%' }}>
    <div style={{ textAlign: 'center' }}>
      <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '0.5rem' }}>
        Generate AI Reading
      </h2>
      <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
        Select a grandparent's voice and which kid this is for
      </p>
    </div>

    {/* Step 1: Select Reader */}
    <div style={{ background: 'white', border: '2px solid #e5e7eb', borderRadius: '0.75rem', padding: '1.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
        <User size={20} color="#3b82f6" />
        <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#1f2937' }}>
          Step 1: Select Grandparent/Reader
        </h3>
      </div>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        {familyReaders && familyReaders.length > 0 ? (
          familyReaders.map((reader) => (
            <div
              key={reader.id}
              onClick={() => onSelectReader(reader)}
              style={{
                padding: '1rem',
                border: selectedReader?.id === reader.id ? '2px solid #3b82f6' : '1px solid #e5e7eb',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                background: selectedReader?.id === reader.id ? '#eff6ff' : 'white',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #db2777, #be185d)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold'
                }}>
                  {reader.first_name?.charAt(0)}{reader.last_name?.charAt(0)}
                </div>
                         <div>
                  <p style={{ fontWeight: '600', color: '#1f2937' }}>
                    {reader.name}
                  </p>
                  {selectedReader?.id === reader.id && availabilityCheck ? (
                    availabilityCheck.has_voice_clone ? (
                      <p style={{ fontSize: '0.75rem', color: '#059669' }}>
                        ✅ Voice clone ready
                      </p>
                    ) : (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <p style={{ fontSize: '0.75rem', color: '#dc2626' }}>
                          ⚠️ No voice clone yet
                        </p>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onStartVoiceClone();
                          }}
                          style={{
                            fontSize: '0.75rem',
                            color: '#3b82f6',
                            background: 'transparent',
                            border: 'none',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            padding: 0
                          }}
                        >
                          Create now
                        </button>
                      </div>
                    )
                  ) : (
                    <p style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                      {reader.has_voice_clone ? '✅ Voice clone ready' : 'Click to check status'}
                    </p>
                  )}
                </div>
              </div>
              {selectedReader?.id === reader.id && (
                <CheckCircle size={24} color="#3b82f6" />
              )}
            </div>
          ))
        ) : (
          <p style={{ color: '#9ca3af', textAlign: 'center', padding: '1rem' }}>
            No readers available
          </p>
        )}
      </div>
    </div>

    {/* Step 2: Select Kid */}
    <div style={{ background: 'white', border: '2px solid #e5e7eb', borderRadius: '0.75rem', padding: '1.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
        <User size={20} color="#3b82f6" />
        <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#1f2937' }}>
          Step 2: Select Kid
        </h3>
      </div>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        {kids && kids.length > 0 ? (
          kids.map((kid) => (
            <div
              key={kid.id}
              onClick={() => onSelectKid(kid)}
              style={{
                padding: '1rem',
                border: selectedKid?.id === kid.id ? '2px solid #3b82f6' : '1px solid #e5e7eb',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                background: selectedKid?.id === kid.id ? '#eff6ff' : 'white',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <div>
                <p style={{ fontWeight: '600', color: '#1f2937' }}>
                  {kid.name || kid.first_name}
                </p>
                <p style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                  Age {kid.age}
                </p>
              </div>
              {selectedKid?.id === kid.id && (
                <CheckCircle size={24} color="#3b82f6" />
              )}
            </div>
          ))
        ) : (
          <p style={{ color: '#9ca3af', textAlign: 'center', padding: '1rem' }}>
            No kids in this family
          </p>
        )}
      </div>
    </div>

    {/* Availability Check */}
    {isChecking && (
      <div style={{ textAlign: 'center', padding: '2rem', background: '#f9fafb', borderRadius: '0.75rem' }}>
        <Loader size={32} color="#3b82f6" style={{ animation: 'spin 1s linear infinite' }} />
        <p style={{ marginTop: '1rem', color: '#6b7280' }}>Checking availability...</p>
      </div>
    )}

    {availabilityCheck && !isChecking && (
      <div
        style={{
          padding: '1.5rem',
          borderRadius: '0.75rem',
          background: availabilityCheck.ai_available ? '#d1fae5' : '#fee2e2',
          border: `2px solid ${availabilityCheck.ai_available ? '#059669' : '#dc2626'}`
        }}
      >
        {availabilityCheck.has_recording ? (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
              <CheckCircle size={20} color="#059669" />
              <p style={{ fontWeight: '600', color: '#065f46' }}>Recording Already Exists!</p>
            </div>
            <p style={{ fontSize: '0.875rem', color: '#047857' }}>
              This book has already been {availabilityCheck.recording_type === 'ai' ? 'generated by AI' : 'recorded manually'}.
            </p>
          </div>
        ) : availabilityCheck.ai_available ? (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
              <CheckCircle size={20} color="#059669" />
              <p style={{ fontWeight: '600', color: '#065f46' }}>Ready to Generate!</p>
            </div>
            <p style={{ fontSize: '0.875rem', color: '#047857' }}>
              {availabilityCheck.generations_remaining} AI generations remaining this month
            </p>
          </div>
        ) : (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
              <AlertCircle size={20} color="#dc2626" />
              <p style={{ fontWeight: '600', color: '#991b1b' }}>Cannot Generate</p>
            </div>
            <p style={{ fontSize: '0.875rem', color: '#b91c1c' }}>
              {availabilityCheck.reason}
            </p>
          </div>
        )}
      </div>
    )}

    {/* Error/Success Messages */}
    {generationError && (
      <div style={{
        padding: '1rem',
        background: '#fee2e2',
        border: '1px solid #dc2626',
        borderRadius: '0.5rem',
        color: '#991b1b',
        fontSize: '0.875rem'
      }}>
        {generationError}
      </div>
    )}

    {generationSuccess && (
      <div style={{
        padding: '1rem',
        background: '#d1fae5',
        border: '1px solid #059669',
        borderRadius: '0.5rem',
        color: '#065f46',
        fontSize: '0.875rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem'
      }}>
        <CheckCircle size={20} color="#059669" />
        AI story generated successfully! Refreshing...
      </div>
    )}

    {/* Action Buttons */}
    <div style={{ display: 'flex', gap: '1rem' }}>
      <button
        onClick={onCancel}
        style={{
          flex: 1,
          padding: '0.75rem 1.5rem',
          border: '1px solid #e5e7eb',
          borderRadius: '0.5rem',
          background: 'white',
          color: '#6b7280',
          fontWeight: '600',
          cursor: 'pointer'
        }}
      >
        Cancel
      </button>
      <button
        onClick={onGenerate}
        disabled={!selectedReader || !selectedKid || !availabilityCheck?.ai_available || isGenerating}
        style={{
          flex: 2,
          padding: '0.75rem 1.5rem',
          border: 'none',
          borderRadius: '0.5rem',
          background: (!selectedReader || !selectedKid || !availabilityCheck?.ai_available || isGenerating) 
            ? '#d1d5db' 
            : 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
          color: 'white',
          fontWeight: '600',
          cursor: (!selectedReader || !selectedKid || !availabilityCheck?.ai_available || isGenerating) 
            ? 'not-allowed' 
            : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.5rem'
        }}
      >
        {isGenerating ? (
          <>
            <Loader size={16} style={{ animation: 'spin 1s linear infinite' }} />
            Generating...
          </>
        ) : (
          <>
            <Sparkles size={16} />
            Generate AI Story
          </>
        )}
      </button>
    </div>
  </div>
);